"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.checkTabsStatus = exports.checkTabInit = void 0;

var checkTabsStatus = function checkTabsStatus(key, getHeightVal) {
  var _a;

  var _childrenNodes = getHeightVal;

  if ((_a = _childrenNodes.current) === null || _a === void 0 ? void 0 : _a.childNodes) {
    var _loop_1 = function _loop_1(i) {
      // 查询到指定要获取高度
      var transformClass = _childrenNodes.current.childNodes[i].childNodes[0];

      if (i == Number(key)) {
        if (transformClass.className.indexOf('price-am-accordion-item-leave') > -1) {
          setTimeout(function () {
            // 24 距离底部距离
            transformClass.lastChild.style.height = transformClass.lastChild.childNodes[0].offsetHeight + "px";
          });
          transformClass.className = 'price-am-accordion-item';
        } else {
          transformClass.lastChild.style.height = '0';
          transformClass.className = 'price-am-accordion-item-leave';
        }
      } else {
        transformClass.lastChild.style.height = '0';
        transformClass.className = 'price-am-accordion-item-leave';
      }
    }; // todo optimize


    for (var i = 0; i < _childrenNodes.current.childNodes.length; i++) {
      _loop_1(i);
    }
  }
};

exports.checkTabsStatus = checkTabsStatus;

var checkTabInit = function checkTabInit(getHeightVal, childrenNodes) {
  var _a, _b;

  if (getHeightVal.current) {
    childrenNodes = getHeightVal.current.childNodes; // todo optimize
    // 12 初始状态下少12 offsetHeight
    // 24 距离底部距离

    for (var i = 0; i < childrenNodes.length; i++) {
      if ((_b = (_a = getHeightVal.current.childNodes) === null || _a === void 0 ? void 0 : _a[i]) === null || _b === void 0 ? void 0 : _b.childNodes[0]) {
        getHeightVal.current.childNodes[i].childNodes[0].lastChild.style.height = getHeightVal.current.childNodes[i].childNodes[0].lastChild.childNodes[0].offsetHeight + "px";
      }
    }
  }
};

exports.checkTabInit = checkTabInit;